import React from "react";
import "./Navbar.scss";
import Hamburger from "../Hamburger/Hamburger";
import { NavLink, withRouter } from "react-router-dom";
import CartIcon from "../CartIcon/CartIcon";

const Navbar = (props) => {
  return (
    <div data-aos="fade-down" data-aos-duration="700" className="Navbar">
      <h2 onClick={() => props.history.push("/")}>BleepSleep</h2>

      <div className="options">
        <NavLink className="link" activeClassName="active" to="/catagories">
          Catagories
        </NavLink>
        <NavLink activeClassName="active" to="/about" className="link">
          About Us
        </NavLink>
        <NavLink activeClassName="active" to="/contact" className="link">
          Contact
        </NavLink>
      </div>

      <CartIcon />
      <Hamburger />
    </div>
  );
};

export default withRouter(Navbar);
